
async function generatePDF() {
    const loader = document.getElementById("pdfLoader");
    loader.classList.add("show");

    let hideLast = true;
    const vertailu = document.querySelector('input[name="vertailu"]:checked');
    if (vertailu && vertailu.value === 'kylla') {
        hideLast = false;
    }

    let hideEmpty = false;
    const piilotatyhjat = document.querySelector('input[name="piilotatyhjat"]:checked');
    if (piilotatyhjat && piilotatyhjat.value === 'kylla') {
        hideEmpty = true;
    }

    let hideRekisterointi = false;
    const jasenyys = document.querySelector('input[name="jasenyys"]:checked');
    if (jasenyys && jasenyys.value === 'ei') {
        hideRekisterointi = true;
    }

    try {
        const { jsPDF } = window.jspdf;
        const pdf = new jsPDF("p", "pt", "a4");

        const margin = 20;
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();
        let currentY = margin;


        /* ---------------------------------------------------------
         * HELPERS
         * --------------------------------------------------------- */

        function ensureSpace(height) {
            if (currentY + height + margin > pageHeight) {
                pdf.addPage();
                currentY = margin;
            }
        }

        /**
         * Draw blue header bar with multiple columns
         */
        function createBlueHeading(columns) {
            const rowHeight = 24;
            const innerPadding = 6; // space inside left and right edge
            ensureSpace(rowHeight);

            const usableWidth = pageWidth - margin * 2;
            const contentWidth = usableWidth - innerPadding * 2;

            // Draw blue bar inside margins
            pdf.setFillColor(0, 92, 171);
            pdf.rect(margin, currentY, usableWidth, rowHeight, "F");

            pdf.setFontSize(9);
            pdf.setTextColor(255, 255, 255);
            pdf.setFont("helvetica", "bold");

            // Ensure there are exactly 6 columns
            while (columns.length < 6) {
                columns.push(""); // fill empty columns if less than 6
            }

            // Define column width percentages for 6 columns (adjust as needed)
            const colPercents = [
                0.25,
                0.16,
                0.16,
                0.17,
                0.17,
                0.09
            ]; // sum should be 1
            let x = margin + innerPadding;

            for (let i = 0; i < 6; i++) {
                const text = columns[i];
                const colWidth = contentWidth * colPercents[i];

                // Alignment: first 2 left, last 4 right
                const align = (i < 2) ? "left" : "right";

                let textX = x;
                if (align === "left") {
                    textX += 2;
                } else if (align === "right") {
                    textX += colWidth - 2;
                }

                pdf.text(text, textX, currentY + rowHeight / 2 + 4, { align });

                x += colWidth;
            }

            currentY += rowHeight + 8;
        }


        function createColorHeading(otsikko, color) {
            const rowHeight = 24;
            const innerPadding = 6; // space inside left and right edge
            ensureSpace(rowHeight);

            const usableWidth = pageWidth - margin * 2;

            pdf.setFillColor(...color);
            pdf.rect(margin, currentY, usableWidth, rowHeight, "F");

            pdf.setFontSize(9);
            pdf.setTextColor(255, 255, 255);
            pdf.setFont("helvetica", "bold");

            // Column starting point
            let x = margin + innerPadding;

            let align = "left";
            let textX = x + 2;

            pdf.text(otsikko, textX, currentY + rowHeight / 2 + 4, {
                align: align
            });

            currentY += rowHeight + 8;
        }

        function createSubTitle(subtitle) {
            const rowHeight = 16;//24;
            const innerPadding = 0; // space inside left and right edge
            ensureSpace(rowHeight);

            const usableWidth = pageWidth - margin * 2;
            const contentWidth = usableWidth - innerPadding * 2;

            // Draw blue bar inside margins
            //pdf.setFillColor(255,255,255);
            //pdf.rect(margin, currentY, usableWidth, rowHeight, "F");

            pdf.setFontSize(9);
            pdf.setTextColor(0,0,0);
            pdf.setFont("helvetica", "bold");

            // Column starting point
            let x = margin + innerPadding;

            let align = "left";
            let textX = x + 2;

            pdf.text(subtitle, textX, currentY + rowHeight / 2 + 4, {
                align: align
            });

            currentY += rowHeight + 8;
        }

        function createHintalaskuririvi(label, row1 = [], row2 = [], row1PriceTexts = [], row2PriceTexts = []) {
            const baseRowHeight = 8;//8;//19;//24;
            const innerPadding = 0;//6; // inside blue bar
            ensureSpace(baseRowHeight);

            const usableWidth = pageWidth - margin * 2;
            const contentWidth = usableWidth - innerPadding * 2;

            pdf.setFontSize(9);
            pdf.setTextColor(0, 0, 0);
            pdf.setFont("helvetica", "normal");

            // Column widths (1 label + 5 columns)
            const colWidths = [
                contentWidth * 0.25, // label
                contentWidth * 0.16, // col1
                contentWidth * 0.16, // col2
                contentWidth * 0.17, // col3
                contentWidth * 0.17, // col4
                contentWidth * 0.09, // col5
            ];

            // Helper: draw wrapped text & return used height
            function drawWrappedText(text, x, y, colWidth, align = "left", lineHeight = 10) {
                const lines = pdf.splitTextToSize(text, colWidth - 4);
                lines.forEach((line, idx) => {
                    pdf.text(line, x, y + idx * lineHeight, { align });
                });
                return lines.length * lineHeight;
            }

            // Draw a single row
            function drawRow(rowArray, priceArray, startY, showLabel = false) {
                let x = margin + innerPadding;
                let maxRowHeight = baseRowHeight;
                let maxDataColsHeight = 0; // <-- exactly what you need

                // Label column
                if (showLabel) {
                    const labelHeight = drawWrappedText(label, x + 2, startY + 10, colWidths[0], "left");
                    maxRowHeight = Math.max(maxRowHeight, labelHeight);
                }
                x += colWidths[0];

                const row = [...rowArray, "", "", "", "", ""].slice(0, 5);
                const prices = [...priceArray, "", "", "", "", ""].slice(0, 5);

                for (let i = 0; i < 5; i++) {
                    const text = row[i];
                    const align = i === 0 ? "left" : "right";
                    const mainX = align === "left" ? x + 2 : x + colWidths[i + 1] - 2;

                    let colHeight = drawWrappedText(text, mainX, startY + 10, colWidths[i + 1], align);

                    if (prices[i]) {
                        pdf.setFontSize(8);
                        colHeight += drawWrappedText(
                            prices[i],
                            mainX,
                            startY + 10 + colHeight,
                            colWidths[i + 1],
                            align,
                            8
                        );
                        pdf.setFontSize(9);
                    }

                    maxRowHeight = Math.max(maxRowHeight, colHeight);
                    maxDataColsHeight = Math.max(maxDataColsHeight, colHeight);

                    x += colWidths[i + 1];
                }

                return [maxRowHeight, maxDataColsHeight];
            }

            function measureRow(rowArray, priceArray, showLabel = false) {
                let maxRowHeight = baseRowHeight;

                // Label column
                if (showLabel) {
                    const lines = pdf.splitTextToSize(label, colWidths[0] - 4);
                    const h = lines.length * 10;
                    maxRowHeight = Math.max(maxRowHeight, h);
                }

                const row = [...rowArray, "", "", "", "", ""].slice(0, 5);
                const prices = [...priceArray, "", "", "", "", ""].slice(0, 5);

                for (let i = 0; i < 5; i++) {
                    // text height
                    const lines = pdf.splitTextToSize(row[i], colWidths[i + 1] - 4);
                    let colHeight = lines.length * 10;

                    // price height
                    if (prices[i]) {
                        const priceLines = pdf.splitTextToSize(prices[i], colWidths[i + 1] - 4);
                        colHeight += priceLines.length * 8;
                    }

                    maxRowHeight = Math.max(maxRowHeight, colHeight);
                }

                return maxRowHeight;
            }

            let requiredHeight = 0;
            if (row1) {
                const h1 = measureRow(row1, row1PriceTexts, true);
                requiredHeight += h1;
                if (row2) requiredHeight += 3; // spacing between rows
            }
            if (row2) {
                const h2 = measureRow(row2, row2PriceTexts, !row1);
                requiredHeight += h2;
            }
            requiredHeight += 11; // bottom padding

            // --- NOW ensure there is enough space ---
            ensureSpace(requiredHeight);


            // ---- Row1 ----
            let row1DataHeight = 0;

            if (row1 && Array.isArray(row1)) {
                const h1 = drawRow(row1, row1PriceTexts, currentY, true);

                // h1[1] = tallest of the 5 main columns
                row1DataHeight = h1[1];

                // Move Y down by only the height of those 5 columns (not the label column)
                if (row2 && Array.isArray(row2)) {
                    currentY += row1DataHeight + 3;  // spacing between rows
                } else {
                    currentY += row1DataHeight;
                }
            }

            // ---- Row2 ----
            if (row2 && Array.isArray(row2)) {
                const h2 = drawRow(row2, row2PriceTexts, currentY, !row1 || row1.length === 0);

                // h2[0] = full height of row2
                currentY += h2[0];
            }

            currentY += 11;  // bottom padding

        }


        function createRyhmacontainers (ryhmacontainers) {
            ryhmacontainers.forEach(ryhmacontainer => {
                if ((hideEmpty && !ryhmacontainer.classList.contains("emptyryhmacontainer")) || !hideEmpty ) {
                    const subtitle = ryhmacontainer.querySelector(".hintalaskuri__subtitlerow .hintalaskuri__subtitle")?.textContent || "";
                    if (subtitle) {
                        createSubTitle(subtitle);
                    }
                    const hintalaskuririvit = ryhmacontainer.querySelectorAll(".hintalaskuririvi.enabled");
                    hintalaskuririvit.forEach(hintalaskuririvi => {

                        if ((hideEmpty && !(hintalaskuririvi.classList.contains("emptykuluttaja") && hintalaskuririvi.classList.contains("emptyyritys"))) || !hideEmpty) {

                            let hrLabel = hintalaskuririvi.querySelector(".hintalaskuririvi__label .labeltext")?.textContent || "";

                            const kuluttajapakkauksetrow = hintalaskuririvi.querySelector(".hintalaskuririvi__container__row.kuluttajapakkaukset");
                            const yrityspakkauksetrow = hintalaskuririvi.querySelector(".hintalaskuririvi__container__row.yrityspakkaukset");

                            let row1 = false;
                            let row2 = false;
                            let row1pricetexts = [];
                            let row2pricetexts = [];


                            if(kuluttajapakkauksetrow) {
                                if (hideEmpty && kuluttajapakkauksetrow.classList.contains("emptyrow")) {
                                    row1 = false;
                                } else {
                                    let hrKuluttajaLabel2 = kuluttajapakkauksetrow.querySelector(".hintalaskuririvi__label2 .labeltext")?.textContent || "";
                                    let hrKuluttajaKilot = kuluttajapakkauksetrow.querySelector(".hintalaskuririvi__kilot input")?.value+" kg" || "";
                                    let hrKuluttajaHinnat1 = kuluttajapakkauksetrow.querySelector(".hintalaskuririvi__hinnat1 input")?.value+" €" || "";
                                    let hrKuluttajaHinnat1Pricetext = kuluttajapakkauksetrow.querySelector(".hintalaskuririvi__hinnat1 .pricetext")?.textContent.trim() || "";
                                    let hrKuluttajaHinnat2 = kuluttajapakkauksetrow.querySelector(".hintalaskuririvi__hinnat2 input")?.value+" €" || "";
                                    let hrKuluttajaHinnat2Pricetext = kuluttajapakkauksetrow.querySelector(".hintalaskuririvi__hinnat2 .pricetext")?.textContent.trim() || "";

                                    if (hrKuluttajaKilot === " kg") {
                                        hrKuluttajaKilot = "0 kg";
                                    }
                                    if (hideLast) {
                                        hrKuluttajaHinnat2 = "";
                                        hrKuluttajaHinnat2Pricetext = "";
                                    }

                                    row1 = [hrKuluttajaLabel2, hrKuluttajaKilot, hrKuluttajaHinnat1, hrKuluttajaHinnat2, ''];
                                    row1pricetexts = ['', '', hrKuluttajaHinnat1Pricetext, hrKuluttajaHinnat2Pricetext, ''];
                                }
                            }

                            if(yrityspakkauksetrow) {
                                if (hideEmpty && yrityspakkauksetrow.classList.contains("emptyrow")) {
                                    row2 = false;
                                } else {
                                    let hrYritysLabel2 = yrityspakkauksetrow.querySelector(".hintalaskuririvi__label2 .labeltext")?.textContent || "";
                                    let hrYritysKilot = yrityspakkauksetrow.querySelector(".hintalaskuririvi__kilot input")?.value+" kg" || "";
                                    let hrYritysHinnat1 = yrityspakkauksetrow.querySelector(".hintalaskuririvi__hinnat1 input")?.value+" €" || "";
                                    let hrYritysHinnat1Pricetext = yrityspakkauksetrow.querySelector(".hintalaskuririvi__hinnat1 .pricetext")?.textContent.trim() || "";
                                    let hrYritysHinnat2 = yrityspakkauksetrow.querySelector(".hintalaskuririvi__hinnat2 input")?.value+" €" || "";
                                    let hrYritysHinnat2Pricetext = yrityspakkauksetrow.querySelector(".hintalaskuririvi__hinnat2 .pricetext")?.textContent.trim() || "";

                                    if (hrYritysKilot === " kg") {
                                        hrYritysKilot = "0 kg";
                                    }
                                    if (hideLast) {
                                        hrYritysHinnat2 = "";
                                        hrYritysHinnat2Pricetext = "";
                                    }
                                    row2 = [hrYritysLabel2, hrYritysKilot, hrYritysHinnat1, hrYritysHinnat2, ''];
                                    row2pricetexts = ['', '', hrYritysHinnat1Pricetext, hrYritysHinnat2Pricetext, ''];
                                }
                            }

                            createHintalaskuririvi(hrLabel, row1, row2, row1pricetexts, row2pricetexts);

                        }
                    });
                }
            });
        }


/*         function yhteenvetoRivi(columns, color, weight, eroColor) {
            const rowHeight = 18;
            const innerPadding = 6; // space inside left and right edge
            let fontweight = weight || 'normal';

            // Make sure we have exactly 6 columns
            while (columns.length < 6) {
                columns.push("");
            }

            // Ensure space for the row (function must exist in your code)
            ensureSpace(rowHeight);

            const usableWidth = pageWidth - margin * 2;

            // Draw background rectangle
            pdf.setFillColor(...color);
            pdf.rect(margin, currentY, usableWidth, rowHeight, "F");

            // Set font properties
            pdf.setFontSize(9);
            pdf.setTextColor(0, 0, 0);
            pdf.setFont("helvetica", fontweight);

            // Define column widths
            const colWidths = [138, 94, 94, 88, 88, 44];
            let colAnchor = margin + innerPadding;

            // Draw text in columns
            for (let i = 0; i < 6; i++) {
                let align = (i < 2) ? "left" : "right";
                let x = colAnchor;
                if (align === "right") {
                    x += colWidths[i]; // move anchor to the right edge
                }
                pdf.text(columns[i], x, currentY + rowHeight / 2 + 4, { align });
                colAnchor += colWidths[i];
            }


            // Move Y position for next row
            currentY += rowHeight;

        } */



        function yhteenvetoRivi(columns, color, weight, eroColor) {
            let fontweight = 'normal';
            const rowHeight = 18;
            const innerPadding = 6; // space inside left and right edge
            ensureSpace(rowHeight);

            const usableWidth = pageWidth - margin * 2;
            const contentWidth = usableWidth - innerPadding * 2;

            pdf.setFillColor(...color);
            pdf.rect(margin, currentY, usableWidth, rowHeight, "F");

            if (weight) {
                fontweight = weight;
            }

            pdf.setFontSize(9);
            pdf.setTextColor(0, 0, 0);
            pdf.setFont("helvetica", fontweight);

            // Ensure there are exactly 6 columns
            while (columns.length < 6) {
                columns.push(""); // fill empty columns if less than 6
            }

            // Define column width percentages for 6 columns (adjust as needed)
            const colPercents = [
                0.25,
                0.16,
                0.16,
                0.17,
                0.17,
                0.09
            ]; // sum should be 1
            let x = margin + innerPadding;

            for (let i = 0; i < 6; i++) {

                const text = columns[i];
                let colWidth = contentWidth * colPercents[i];

                // Alignment: first 2 left, last 4 right
                const align = (i < 2) ? "left" : "right";

                let textX = x;
                if (align === "left") {
                    textX += 2;
                } else if (align === "right") {
                    textX += colWidth - 2;
                }

                if (i === 5) {
                    pdf.setTextColor(...eroColor);
                }

                pdf.text(text, textX, currentY + rowHeight / 2 + 4, { align });

                if (i === 5) {
                    pdf.setTextColor(0, 0, 0);
                }

                x += colWidth;
            }

            currentY += rowHeight;
        }

        function createYhteenvetoRows(yhteenvetoriviLabel, yhteenvetoriviRows, color) {
            let rowCount = yhteenvetoriviRows.length + 1;
            ensureSpace(rowCount * 18);

            yhteenvetoriviRows.forEach((yhteenvetoriviRow, index) => {
                let row1 = false;

                const label = index === 0 ? yhteenvetoriviLabel : "";
                const weight = index < 3 ? "normal" : "bold";

                let yhteenvetoLabel2 = yhteenvetoriviRow.querySelector(".yhteenvetorivi__label2 .labeltext")?.textContent || "";

                let rawKilot = yhteenvetoriviRow.querySelector(".yhteenvetorivi__kilot input")?.value || "";
                let yhteenvetoKilot = index < 3 ? rawKilot + " kg" : rawKilot;

                let yhteenvetoHinnat1 = yhteenvetoriviRow.querySelector(".yhteenvetorivi__hinnat1 input")?.value+" €" || "";
                let yhteenvetoHinnat2 = yhteenvetoriviRow.querySelector(".yhteenvetorivi__hinnat2 input")?.value+" €" || "";

                let yhteenvetoEro = yhteenvetoriviRow.querySelector(".yhteenvetorivi__ero input")?.value+" %" || "";
                let yhteenvetoEroEl = yhteenvetoriviRow.querySelector(".yhteenvetorivi__ero input");

                let eroColor = [0,0,0];
                if (yhteenvetoEroEl.classList.contains("isbigger")) {
                    eroColor = [255, 0, 0];
                } else if(yhteenvetoEroEl.classList.contains("issmaller")) {
                    eroColor = [0, 128, 0];
                }

                if(hideLast) {
                    yhteenvetoHinnat2 = "";
                    yhteenvetoEro = "";
                }

                row1 = [label, yhteenvetoLabel2, yhteenvetoKilot, yhteenvetoHinnat1, yhteenvetoHinnat2, yhteenvetoEro];
                yhteenvetoRivi(row1, color, weight, eroColor);
            });
        }



        //
        // 1. YRITYSMAKSUT HEADER
        //
        const yritysmaksut = document.querySelector(".hintalaskuri__taulukko__yritysmaksut");
        if (yritysmaksut) {
            let ymLabel = yritysmaksut.querySelector(".hintalaskuriotsikkorivi__label .labeltext")?.textContent || "";
            let ymCompany1 = yritysmaksut.querySelector(".hintalaskuriotsikkorivi__company1 .labeltext")?.textContent || "";
            let ymCompany2 = yritysmaksut.querySelector(".hintalaskuriotsikkorivi__company2 .labeltext")?.textContent || "";
            if (hideLast) {
                ymCompany2 = "";
            }

            createBlueHeading(
                [ymLabel, "", "", ymCompany1, ymCompany2, ""]
            );

            const yritysmaksutRyhma = yritysmaksut.querySelector(".hintalaskuri__taulukko__ryhma");
            const yritysmaksutRyhmaHintarivit = yritysmaksutRyhma.querySelectorAll(".hintalaskuririvi.enabled");

            yritysmaksutRyhmaHintarivit.forEach(yritysmaksutHintarivi => {
                let hrLabel = yritysmaksutHintarivi.querySelector(".hintalaskuririvi__label .labeltext")?.textContent || "";

                let row1 = false;
                let row2 = false;
                let row1pricetexts = [];
                let row2pricetexts = [];

                let yritysmaksuHinnat1 = yritysmaksutHintarivi.querySelector(".hintalaskuririvi__hinnat1 input")?.value+" €" || "";
                let yritysmaksuHinnat1Pricetext = yritysmaksutHintarivi.querySelector(".hintalaskuririvi__hinnat1 .pricetext")?.textContent.trim() || "";
                let yritysmaksuHinnat2 = yritysmaksutHintarivi.querySelector(".hintalaskuririvi__hinnat2 input")?.value+" €" || "";
                let yritysmaksuHinnat2Pricetext = yritysmaksutHintarivi.querySelector(".hintalaskuririvi__hinnat2 .pricetext")?.textContent.trim() || "";


                if (hideLast) {
                    yritysmaksuHinnat2 = "";
                    yritysmaksuHinnat2Pricetext = "";
                }

                row1 = ['', '', yritysmaksuHinnat1, yritysmaksuHinnat2, ''];
                row1pricetexts = ['', '', yritysmaksuHinnat1Pricetext, yritysmaksuHinnat2Pricetext, ''];

                createHintalaskuririvi(hrLabel, row1, row2, row1pricetexts, row2pricetexts);

            });

        }


        //
        // 2. KIERRÄTYSMAKSUT HEADER
        //
        currentY += 6;

        const kierratysmaksut = document.querySelector(".hintalaskuri__taulukko__kierratysmaksut");
        if (kierratysmaksut) {
            let kmLabel = kierratysmaksut.querySelector(".hintalaskuriotsikkorivi__label .labeltext")?.textContent || "";
            let kmKilot = kierratysmaksut.querySelector(".hintalaskuriotsikkorivi__kilot .labeltext")?.textContent || "";
            let kmCompany1 = kierratysmaksut.querySelector(".hintalaskuriotsikkorivi__company1 .labeltext")?.textContent || "";
            let kmCompany2 = kierratysmaksut.querySelector(".hintalaskuriotsikkorivi__company2 .labeltext")?.textContent || "";
            if (hideLast) {
                kmCompany2 = "";
            }
            createBlueHeading(
                [kmLabel, "", kmKilot, kmCompany1, kmCompany2, ""]
            );




            const paperikuituRyhma = kierratysmaksut.querySelector(".hintalaskuri-paperikuitu.hintalaskuri__taulukko__ryhma.enabled.showpdf");
            if (paperikuituRyhma) {
                if ((hideEmpty && !paperikuituRyhma.classList.contains("emptyryhma")) || !hideEmpty ) {
                    const ryhmaOtsikko = paperikuituRyhma.querySelector(".hintalaskuri__titlerow .hintalaskuri__title")?.textContent || "";
                    const color = [209, 172, 113];
                    createColorHeading(ryhmaOtsikko, color);

                    const ryhmacontainers = paperikuituRyhma.querySelectorAll(".ryhmacontainer");
                    createRyhmacontainers(ryhmacontainers);

                    currentY += 6;
                }
            }

            const muoviRyhma = kierratysmaksut.querySelector(".hintalaskuri-muovi.hintalaskuri__taulukko__ryhma.enabled.showpdf");
            if (muoviRyhma) {
                if ((hideEmpty && !muoviRyhma.classList.contains("emptyryhma")) || !hideEmpty ) {
                    const ryhmaOtsikko = muoviRyhma.querySelector(".hintalaskuri__titlerow .hintalaskuri__title")?.textContent || "";
                    const color = [151, 42, 135];
                    createColorHeading(ryhmaOtsikko, color);

                    const ryhmacontainers = muoviRyhma.querySelectorAll(".ryhmacontainer");
                    createRyhmacontainers(ryhmacontainers);

                    currentY += 6;
                }
            }

            const metalliRyhma = kierratysmaksut.querySelector(".hintalaskuri-metalli.hintalaskuri__taulukko__ryhma.enabled.showpdf");
            if (metalliRyhma) {
                if ((hideEmpty && !metalliRyhma.classList.contains("emptyryhma")) || !hideEmpty ) {
                    const ryhmaOtsikko = metalliRyhma.querySelector(".hintalaskuri__titlerow .hintalaskuri__title")?.textContent || "";
                    const color = [94, 117, 144];
                    createColorHeading(ryhmaOtsikko, color);

                    const ryhmacontainers = metalliRyhma.querySelectorAll(".ryhmacontainer");
                    createRyhmacontainers(ryhmacontainers);

                    currentY += 6;
                }
            }

            const lasiRyhma = kierratysmaksut.querySelector(".hintalaskuri-lasi.hintalaskuri__taulukko__ryhma.enabled.showpdf");
            if (lasiRyhma) {
                if ((hideEmpty && !lasiRyhma.classList.contains("emptyryhma")) || !hideEmpty ) {
                    const ryhmaOtsikko = lasiRyhma.querySelector(".hintalaskuri__titlerow .hintalaskuri__title")?.textContent || "";
                    const color = [15, 182, 148];
                    createColorHeading(ryhmaOtsikko, color);

                    const ryhmacontainers = lasiRyhma.querySelectorAll(".ryhmacontainer");
                    createRyhmacontainers(ryhmacontainers);

                    currentY += 6;
                }
            }

            const puuRyhma = kierratysmaksut.querySelector(".hintalaskuri-puu.hintalaskuri__taulukko__ryhma.enabled.showpdf");
            if (puuRyhma) {
                if ((hideEmpty && !puuRyhma.classList.contains("emptyryhma")) || !hideEmpty ) {
                    const ryhmaOtsikko = puuRyhma.querySelector(".hintalaskuri__titlerow .hintalaskuri__title")?.textContent || "";
                    const color = [125, 92, 59];
                    createColorHeading(ryhmaOtsikko, color);

                    const ryhmacontainers = puuRyhma.querySelectorAll(".ryhmacontainer");
                    createRyhmacontainers(ryhmacontainers);

                    currentY += 6;
                }
            }

        }

        //
        // 4. SUMMARY (YHTEENVETO)
        //

        currentY += 6;
        const yhteenveto = document.querySelector(".hintalaskuri__yhteenveto");
        if (yhteenveto) {
            const yvLabel = yhteenveto.querySelector(".yhteenvetootsikkorivi__label .labeltext")?.textContent || "";
            const yvKilot = yhteenveto.querySelector(".yhteenvetootsikkorivi__kilot .labeltext")?.textContent || "";
            const yvCompany1 = yhteenveto.querySelector(".yhteenvetootsikkorivi__company1 .labeltext")?.textContent || "";
            let yvCompany2 = yhteenveto.querySelector(".yhteenvetootsikkorivi__company2 .labeltext")?.textContent || "";
            let yvEro = yhteenveto.querySelector(".yhteenvetootsikkorivi__ero .labeltext")?.textContent || "";
            if (hideLast) {
                yvCompany2 = "";
                yvEro = "";
            }

            createBlueHeading(
                [yvLabel, "", yvKilot, yvCompany1, yvCompany2, yvEro]
            );




            const paperikuituYhteenveto = yhteenveto.querySelector(".yhteenveto-paperikuitu.enabled");
            if (paperikuituYhteenveto) {
                if ((hideEmpty && !paperikuituYhteenveto.classList.contains("emptyyhteenvetorivi")) || !hideEmpty ) {
                    const color = [246, 239, 228];
                    const yhteenvetoriviLabel = paperikuituYhteenveto.querySelector(".yhteenvetorivi__label .labeltext")?.textContent || "";

                    const yhteenvetoriviRows = paperikuituYhteenveto.querySelectorAll(".yhteenvetorivi__container__row");
                    createYhteenvetoRows(yhteenvetoriviLabel, yhteenvetoriviRows, color);

                    currentY += 6;
                }
            }

            const muoviYhteenveto = yhteenveto.querySelector(".yhteenveto-muovi.enabled");
            if (muoviYhteenveto) {
                if ((hideEmpty && !muoviYhteenveto.classList.contains("emptyyhteenvetorivi")) || !hideEmpty ) {
                    const color = [235, 216, 232];
                    const yhteenvetoriviLabel = muoviYhteenveto.querySelector(".yhteenvetorivi__label .labeltext")?.textContent || "";

                    const yhteenvetoriviRows = muoviYhteenveto.querySelectorAll(".yhteenvetorivi__container__row");
                    createYhteenvetoRows(yhteenvetoriviLabel, yhteenvetoriviRows, color);

                    currentY += 6;
                }
            }

            const metalliYhteenveto = yhteenveto.querySelector(".yhteenveto-metalli.enabled");
            if (metalliYhteenveto) {
                if ((hideEmpty && !metalliYhteenveto.classList.contains("emptyyhteenvetorivi")) || !hideEmpty ) {
                    const color = [225, 229, 234];
                    const yhteenvetoriviLabel = metalliYhteenveto.querySelector(".yhteenvetorivi__label .labeltext")?.textContent || "";

                    const yhteenvetoriviRows = metalliYhteenveto.querySelectorAll(".yhteenvetorivi__container__row");
                    createYhteenvetoRows(yhteenvetoriviLabel, yhteenvetoriviRows, color);

                    currentY += 6;
                }
            }

            const lasiYhteenveto = yhteenveto.querySelector(".yhteenveto-lasi.enabled");
            if (lasiYhteenveto) {
                if ((hideEmpty && !lasiYhteenveto.classList.contains("emptyyhteenvetorivi")) || !hideEmpty ) {
                    const color = [213, 241, 234];
                    const yhteenvetoriviLabel = lasiYhteenveto.querySelector(".yhteenvetorivi__label .labeltext")?.textContent || "";

                    const yhteenvetoriviRows = lasiYhteenveto.querySelectorAll(".yhteenvetorivi__container__row");
                    createYhteenvetoRows(yhteenvetoriviLabel, yhteenvetoriviRows, color);

                    currentY += 6;
                }
            }

            const puuYhteenveto = yhteenveto.querySelector(".yhteenveto-puu.enabled");
            if (puuYhteenveto) {
                if ((hideEmpty && !puuYhteenveto.classList.contains("emptyyhteenvetorivi")) || !hideEmpty ) {
                    const color = [231, 224, 219];
                    const yhteenvetoriviLabel = puuYhteenveto.querySelector(".yhteenvetorivi__label .labeltext")?.textContent || "";

                    const yhteenvetoriviRows = puuYhteenveto.querySelectorAll(".yhteenvetorivi__container__row");
                    createYhteenvetoRows(yhteenvetoriviLabel, yhteenvetoriviRows, color);

                    currentY += 6;
                }
            }

            const yhteensaYhteenveto = yhteenveto.querySelector(".yhteenveto-yhteensa.enabled");
            if (yhteensaYhteenveto) {
                if ((hideEmpty && !yhteensaYhteenveto.classList.contains("emptyyhteenvetorivi")) || !hideEmpty ) {
                    const color = [238, 245, 250];
                    const yhteenvetoriviLabel = yhteensaYhteenveto.querySelector(".yhteenvetorivi__label .labeltext")?.textContent || "";

                    const yhteenvetoriviRows = yhteensaYhteenveto.querySelectorAll(".yhteenvetorivi__container__row");
                    createYhteenvetoRows(yhteenvetoriviLabel, yhteenvetoriviRows, color);

                    currentY += 6;
                }
            }




        }


        /* ---------------------------------------------------------
         * SAVE PDF / UPLOAD (unchanged)
         * --------------------------------------------------------- */
        const pdfBlob = pdf.output("blob");

        const formData = new FormData();
        formData.append("pdf", pdfBlob, "combined.pdf");

        const response = await fetch("/wp-admin/admin-ajax.php?action=save_laskuri_pdf", {
            method: "POST",
            body: formData
        }).then(r => r.json());

        if (response.url) {
            window.open(response.url, "_blank");
        }

    } finally {
        loader.classList.remove("show");
    }
}


document.addEventListener("DOMContentLoaded", () => {
    const button = document.getElementById("downloadPdf");
    if (button) {
        button.addEventListener("click", () => {
            generatePDF();
            button.blur();
        });
    }
});
